import React from "react";
import Html from "./html";
import { Provider } from "./provider";

const RemedialJobs = () => {
    return (
        <Provider>
            <Html/>
        </Provider>
    );
}

export default RemedialJobs;